import { FC } from 'react';

import {
  BaseTextField,
  BasicTextFieldProps,
} from '~components/form/base-text-field/base-text-field';
import { PhoneMaskInput } from '~components/form/mask-inputs/phone-mask-input';
import { AppIcon } from '~components/shared/app-icon/app-icon';

import { ReactComponent as IconMobilePhone } from '~assets/icons/icon-mobile-phone.svg';

type Props = Partial<BasicTextFieldProps> & { name: string };

export const BasePhoneInput: FC<Props> = ({ label = 'Телефон', ...props }) => {
  return (
    <BaseTextField
      dynamic={false}
      label={label}
      {...props}
      placeholder="+38 (0__) ___-__-__"
      InputProps={{
        inputComponent: PhoneMaskInput as any,
      }}
      startIcon={<AppIcon component={IconMobilePhone} size={18} />}
    />
  );
};
